import Rellax from 'rellax'

export function rellax() {
	const elements = document.querySelectorAll('.rellax')
	if (!elements.length) return

	// Disable on mobile
	if (window.innerWidth < 1024) return

	new Rellax('.rellax', {
		speed: -2,
		center: true,
		wrapper: null,
		round: false,
		vertical: true,
		horizontal: false
	})
}